import { render, staticRenderFns } from "./PhoneCodeSheet.vue?vue&type=template&id=4afe0978"
import script from "./PhoneCodeSheet.vue?vue&type=script&lang=js"
export * from "./PhoneCodeSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports